// doctor-frontend/src/pages/chc/PharmacyDashboard.jsx
// Workbench for pharmacists in the CHC flow. Lists prescriptions
// approved by the Medical Officer, allows the pharmacist to dispense
// medication, record batch numbers and quantities, and mark prescriptions
// as delivered to the citizen.

import React from 'react';
import { Box, Typography } from '@mui/material';

export default function PharmacyDashboard() {
  return (
    <Box p={2} className="min-h-screen">
      <Typography variant="h6" gutterBottom>
        Pharmacy
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        View authorised prescriptions, dispense medicines, record batch
        numbers and expiry dates, and mark the prescription as dispensed.
      </Typography>
      {/* Future enhancements: list of prescriptions, stock management,
          dispensing form with quantity tracking. */}
    </Box>
  );
}